import { AuditActionList, AuditEventList, type AuditEventQuery } from '@regigov/contracts';
import { api } from './client';

export const auditApi = {
  events: (query: AuditEventQuery) => {
    const p = new URLSearchParams(Object.entries(query).filter((e): e is [string, string | number] => e[1] !== undefined && e[1] !== '').map(([k, v]) => [k, String(v)]));
    return api(`/audit/events?${p}`, AuditEventList);
  },
  actions: () => api('/audit/actions', AuditActionList),
};
